import MainHeader from './main-header/main-header';
import MobileMenu from './mobile-menu';
import SubHeaderNavSlider from './sub-header-nav-slider';

export default [
  new MainHeader('.js-main-header'),
  new MobileMenu({
    openButtonSelector: '.js-open-mobile',
    menuModalSelector: '.js-mobile-menu',
    navSectionSelector: '.js-mobile-nav',
    closeButtonSelector: '.js-close-button',
  }),
  new SubHeaderNavSlider('.js-scrollable-tabs-nav', '.js-is-active'),
];
